module.exports = __webpack_public_path__ + "img/icon-crypto.23058044.svg";